import React, { useState } from 'react';
import { Copy, Check, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

const CONTRACT = '0x1e776f23f9849b40f37820c9ca86aee59cd27777';

const TokenSection = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = CONTRACT;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast('Contract address copied', { description: CONTRACT });
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <section id="token" className="token-section" data-testid="token-section">
      <img src="/brand/mark-green.png" alt="" aria-hidden="true" className="token-watermark" />
      <div className="token-inner">
        <span className="section-label-new">[ $ZYBER TOKEN ]</span>
        <h2 className="token-heading">
          One token for the <span className="gradient-text">whole layer</span>
        </h2>
        <p className="token-desc">
          $ZYBER powers secure, private access across every AI platform. Launched via{' '}
          <a href="https://flap.sh" target="_blank" rel="noopener noreferrer" className="token-link">
            flap.sh
          </a>
          .
        </p>

        <div className="token-contract" data-testid="token-contract">
          <span className="contract-label">Contract</span>
          <code className="contract-address" data-testid="token-contract-address">{CONTRACT}</code>
          <button
            className="contract-copy"
            onClick={handleCopy}
            aria-label="Copy contract address"
            data-testid="token-copy-btn"
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
            <span>{copied ? 'Copied' : 'Copy'}</span>
          </button>
        </div>

        <a href="https://flap.sh" target="_blank" rel="noopener noreferrer" className="btn-ghost token-cta" data-testid="token-flap-btn">
          View on flap.sh
          <ExternalLink size={15} />
        </a>
      </div>
    </section>
  );
};

export default TokenSection;
